// import { createSlice } from "@reduxjs/toolkit";
 
// const initialState = {
//   salesPersonDataSource: [] as string[],
// };
 
// const salesSlice = createSlice({
//   name: "sales",
//   initialState,
//   reducers: {
//     setSalesPersonDataSource(state, action) {
//       state.salesPersonDataSource = action.payload;
//     },
//   },
// });
 
// export const { setSalesPersonDataSource } = salesSlice.actions;
// export const selectSalesPersonDataSource = (state: any) =>
//   state.sales.salesPersonDataSource;
// export const salesReducer = salesSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";
 
const initialState = {
  salesPersonDataSource: [] as string[],
};
 
const salesRepSlice = createSlice({
  name: "salesRep",
  initialState,
  reducers: {
    setSalesPersonDataSource(state, action) {
      state.salesPersonDataSource = action.payload;
    },
  },
});
 
export const { setSalesPersonDataSource } = salesRepSlice.actions;
export const salesRepReducer = salesRepSlice.reducer;
 
// Selector
// export const selectSalesPersonDataSource = (state: any) =>
//   state.salesRep.salesPersonDataSource;

export const selectSalesPersonDataSource = (state: any) =>
    state?.salesRep?.salesPersonDataSource || [];